import { Button } from "antd";
import React, { useEffect, useRef, useState } from "react";
import globalStyles from "../../components.module.css";
import FieldHeader from "../FieldHeader";
import emojis from "./emoji.json";
import styles from "./emoji.module.css";

const Emoji = ({ parameters, value, onChange }) => {
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [displayPicker, setDisplayPicker] = useState(false);
  const emojisListRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (emojisListRef.current && !emojisListRef.current.contains(e.target)) {
        setDisplayPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojisListRef]);

  useEffect(() => {
    if (parameters.default) {
      onChange(parameters.default);
    }
    setChosenEmoji(value);
  }, []);

  useEffect(() => {
    if (chosenEmoji) {
      onChange(chosenEmoji);
    }
  }, [chosenEmoji]);

  return (
    <div className={globalStyles.form_control}>
      <FieldHeader
        label={parameters.label}
        description={parameters.description}
      />
      <div className={styles.emoji_select_container}>
        {chosenEmoji ? (
          <span
            className={styles.emoji}
            onClick={() => !displayPicker && setDisplayPicker(true)}
          >
            {chosenEmoji}
          </span>
        ) : (
          <Button
            onClick={() => !displayPicker && setDisplayPicker(true)}
            type="default"
          >
            Choose icon
          </Button>
        )}
      </div>
      {displayPicker && (
        <div className={styles.emojis_container} ref={emojisListRef}>
          <span className={styles.emoji} onClick={() => setChosenEmoji(null)}>
            &#8709;
          </span>
          {emojis.emojis.map((emoji, index) => (
            <span
              className={styles.emoji}
              key={index}
              onClick={() => setChosenEmoji(emoji.emoji)}
            >
              {emoji.emoji}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Emoji;
